(function() {
    function markIframes() {
        document.querySelectorAll('iframe:not([data-uw-iframe-ignore])').forEach(function(iframe) {
            iframe.setAttribute('data-uw-iframe-ignore', '');
        });
    }

    function initUserWay() {
        markIframes();
        const observer = new MutationObserver(markIframes);
        observer.observe(document.body, { childList: true, subtree: true });
        document.addEventListener('gform_post_render', markIframes);

        var s = document.createElement('script');
        s.src = 'https://cdn.userway.org/widget.js';
        s.setAttribute('data-account', '8qQO3qIpQk');
        s.async = true;
        document.head.appendChild(s);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initUserWay);
    } else {
        initUserWay();
    }
})();
